import React, { Component } from "react";
import PageHelmet from "../component/common/Helmet";
import ModalVideo from 'react-modal-video';
import {FaTwitter ,FaInstagram ,FaFacebookF , FaLinkedinIn} from "react-icons/fa";
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from "react-icons/fi";
import Header from "../component/header/Header";
import Footer from "../component/footer/Footer";

const SocialShare = [
    {Social: <FaFacebookF /> , link: 'https://www.facebook.com/'},
    {Social: <FaLinkedinIn /> , link: 'https://www.linkedin.com/'},
    {Social: <FaInstagram /> , link: 'https://www.instagram.com/'},
    {Social: <FaTwitter /> , link: 'https://twitter.com/'},
]

class FenamixDetails extends Component{
    constructor () {
        super()
        this.state = {
          isOpen: false
        }
        this.openModal = this.openModal.bind(this)
    }
    openModal () {
        this.setState({isOpen: true})
    }
    render(){
        return(
            <React.Fragment>
                <PageHelmet pageTitle='Visita Tamaulipas' />

                <Header headertransparent="header--transparent" colorblack="color--black" logoname="logo.png" />
                
                {/* Start Breadcrump Area */}
                <div className="rn-page-title-area pt--120 pb--190 bg_image bg_image--4"  data-black-overlay="7">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="rn-page-title text-center pt--100">
                                    <h2 className="title theme-gradient">LOTERÍAS FENAMIX</h2>
                                    <p>Información de puntos de lotería de España. </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Breadcrump Area */}

                {/* Start Portfolio Details */}
                <div className="rn-portfolio-details ptb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="portfolio-details">
                                    <div className="inner">
                                        <h2>Loterías Fenamix</h2>
                                        <p className="subtitle">Aplicación móvil para la gestión de tiendas de loterías de España</p>
                                        <p>Aplicación que permite acceder a la información de todos los puntos de lotería de España a través de escánear un código QR único por establecimiento. También permite ver la lotería desde la propia aplicación y acceder a información de los locales única. El proyecto también cuenta con un panel admin desarrollado desde 0 para la gestión de los diferentes locales. </p>
                                        <p>Proyecto solicitado por la asociación de loterías Fenamix para su salida a finales de 2022.</p>

                                        <div className="portfolio-view-list d-flex flex-wrap">
                                            <div className="port-view">
                                                <span>Framework Frontend</span>
                                                <h4>Flutter (Móvil)</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Framework Backend</span>
                                                <h4>Laravel</h4>
                                            </div>

                                            <div className="port-view">
                                                <span>Lenguajes</span>
                                                <h4>Dart & PHP</h4>
                                            </div>
                                        </div>

                                        <div className="portfolio-share-link mt--20 pb--70 pb_sm--40">
                                            <div className="header-btn">
                                                <a className="rn-btn" href="https://play.google.com/store/apps/details?id=com.nearldev.fenamix.virtualcard&hl=es&gl=ES">
                                                    <span>Ver app en Play Store</span>
                                                </a>
                                            </div>
                                            <div className="header-btn mt--15 ">
                                                <a className="rn-btn" href="https://apps.apple.com/app/fenamix/id6444050675">
                                                    <span>Ver app en App Store</span>
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                               
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* End Portfolio Details */}

                {/* Start Related Work */}
                <div className="portfolio-related-work pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <span className="theme-color font--18 fontWeight600">Proyectos relacionados</span>
                                    <h2>Otros proyectos</h2>
                                </div>
                            </div>
                        </div>
                        <div className="row mt--10">
                            {/* Start Single Portfolio */}
                            <div className="col-lg-6 col-md-6 col-12 text-center">
                                <div className="related-work text-center mt--30">
                                    <div className="thumb">
                                        <a href="/fenamix-details">
                                            <img src="/assets/images/portfolio/dp-portfolio-03.jpg" alt="Portfolio-images"/>
                                        </a>
                                    </div>
                                    <div className="content">
                                        <div className="inner">
                                            <p>Aplicación móvil - Flutter</p>
                                            <h4><a href="/fenamix-details">Aplicación de gestión de aforo del evento Congreso Fenamix V</a></h4>
                                        </div>
                                    </div>
                                </div>
                        </div>
                        {/* End Single Portfolio */}
                        </div>
                    </div>
                </div>
                {/* End Related Work */}

                {/* Start Back To Top */}
                <div className="backto-top">
                    <ScrollToTop showUnder={160}>
                        <FiChevronUp />
                    </ScrollToTop>
                </div>
                {/* End Back To Top */}
                
                <Footer />  


            </React.Fragment>
        )
    }
}
export default FenamixDetails;
